import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../types/api-response.type';
import { RemoteVideoMedia } from '../../types/remote-video.type';
import { ApiService } from '../api/api.service';
import { DocumentationTerms } from '../../enum/documentation-terms.enum';

@Injectable({
  providedIn: 'root',
})
export class RemoteVideoService extends ApiService<RemoteVideoMedia> {
  constructor() {
    super();
    this.moduleUrl.set('/jsonapi/media/remote_video');
  }

  /**
   * Obtiene vídeos remotos filtrados por término de sección
   * @param term Término de documentación para filtrar
   * @returns Observable con la respuesta de la API
   */
  getDocumentsByTerm(
    term: DocumentationTerms,
  ): Observable<ApiResponse<RemoteVideoMedia[]>> {
    const headers = {
      Accept: 'application/vnd.api+json',
    };

    const params: any = {
      'filter[field_sections.name]': term,
    };

    return this.http.get<ApiResponse<RemoteVideoMedia[]>>(this.url(), {
      headers,
      params,
    });
  }
}
